/** One-time welcome credits modal after first profile create → /my-discovery */
export const PROFILE_WELCOME_CREDITS_KEY = "gt:showProfileWelcomeCredits";
